import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import { useUserInfo } from 'queries/user-action/use-user-info';

import useStyles from './styles';

interface Props {
    className?: string;
}

const StartTrialButton: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const { data: user, isPending, isLoading } = useUserInfo();

    if (isPending || isLoading) {
        return null;
    }

    if (user) {
        return (
            <Link className={cx(classes.email, className)} to={'/userinfo'}>
                {user.email}
            </Link>
        );
    }

    return (
        <Button
            disableElevation
            disableRipple
            variant="outlined"
            color="inherit"
            className={cx(classes.button, className)}
            component={Link}
            to={'/login'}
        >
            {'Sign in'}
        </Button>
    );
};

export default StartTrialButton;
